import { useQuery } from "@tanstack/react-query";

import type { MonitorAndProtectModelSharedRequestDeviceType } from "@similarweb/pro-api-client/dist/generated/data-contracts";

import { apiClient } from "app/modules/api-client";

export const useCampaignWidgetsMetrics = (
    campaignId: string,
    enabled: boolean,
    countries: number[],
    device: MonitorAndProtectModelSharedRequestDeviceType = "All",
) => {
    return useQuery({
        queryKey: ["campaign-widgets-metrics", campaignId, [...countries].sort(), device],
        queryFn: () =>
            apiClient.MonitorAndProtectMaster.monitorandprotectCompetitorsreportWidgetsCreate(campaignId, {
                device,
                countries,
            }),
        enabled,
    });
};
